// @ts-nocheck
/* eslint-disable */
import MyMapsPopup from "~/es6/mymaps.popup";
import { _ } from "~/i18n";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

window.PathEditPopup = class extends MyMapsPopup {
	set data(data) {
		this._data = data;

		this._dom.title.innerHTML = Mapy.Util.escapeHTML(this._data.title);
		this._dom.editTitle.innerHTML = Mapy.Util.escapeHTML(this._data.title);
		this._dom.deleteTitle.innerHTML = _("mymap.activity.edit.deleteTitle", { trackTitle: Mapy.Util.escapeHTML(this._data.title) });
		this._dom.deleteText.textContent = _("path.deleteText");
	}

	get title() {
		return this._dom.editTitle.value.trim();
	}

	open(type, data) {
		super.open();

		this.data = data;
		this._dom.editContainer.classList[type == "edit" ? "remove" : "add"]("hide");
		this._dom.deleteContainer.classList[type == "remove" ? "remove" : "add"]("hide");
		this._dom.container.addEventListener("click", this);

		if (type == "edit") {
			this._dom.editTitle.focus();
		}
	}

	close() {
		super.close();
		this._dom.container.removeEventListener("click", this);
	}

	handleEvent(e) {
		super.handleEvent(e);

		if (e.type == "click") {
			let logger = Mapy.getComponent("logger");
			switch (e.target) {
				case this._dom.cancelBtn:
				case this._dom.cancelDeleteBtn:
					this.close();
					break;

				case this._dom.saveBtn:
					let usertitle = this.title;

					if (usertitle) {
						Mapy.ProviderMapyBox.likeUpdate(this._data.id, {
							usertitle
						}).then(r => {
							this.close();
							Notifications.notify({
								content: _("path.edit"),
								type: NOTIFICATIONS_TYPE.SUCCESS
							});

							this._sendSignal("updated");
						}, r => {
							this._addError(this._dom.editContainer, _("mymap.activity.notify.editError"));
						});
					}
					break;

				case this._dom.deleteBtn:
					Mapy.ProviderMapyBox.likeDelete([this._data.id]).then(r => {
						this.close();
						Notifications.notify({
							content: _("path.notify.delete"),
							type: NOTIFICATIONS_TYPE.SUCCESS
						});
						logger.log("my_maps_item_delete", {type: "path"});
						this._sendSignal("deleted", this._data.id);
					}, r => {
						Notifications.notify({
							content: _("path.notify.deleteError"),
							type: NOTIFICATIONS_TYPE.ERROR
						});
						this.close();
					});
					break;
			}
		}
	}

	_create() {
		super._create();
		this._dom.container.classList.add("path-edit");
		this._createEdit();
		this._createDelete();
	}

	_createEdit() {
		let editContainer = Mapy.Util.node("div", {});
		let header = Mapy.Util.node("div", { className: "header" });
		let title = Mapy.Util.node("h3", {}, _("edit") + " ");
		let itemTitle = Mapy.Util.node("b", {});
		title.appendChild(itemTitle);
		this._dom.title = itemTitle;
		header.appendChild(title);
		editContainer.appendChild(header);

		let span = Mapy.Util.node("span", {}, _("path.titleEdit"));
		let div = Mapy.Util.node("div");
		let editTitle = Mapy.Util.node("input", { type: "text" });

		this._dom.editTitle = editTitle;
		editContainer.appendChild(span);
		div.appendChild(editTitle);
		editContainer.appendChild(div);

		let buttons = Mapy.Util.node("div", { className: "buttons" });
		let cancelBtn = Mapy.Util.node("button", { className: "cancel", textContent: _("cancel") });
		cancelBtn.setAttribute("type", "button");
		let saveBtn = Mapy.Util.node("button", { className: "save", textContent: _("save") });
		saveBtn.setAttribute("type", "button");
		buttons.appendChild(saveBtn);
		buttons.appendChild(cancelBtn);
		this._dom.buttons = buttons;
		this._dom.saveBtn = saveBtn;
		this._dom.cancelBtn = cancelBtn;
		editContainer.appendChild(buttons);

		this._dom.editContainer = editContainer;
		this._dom.container.appendChild(this._dom.editContainer);
	}

	_createDelete() {
		let deleteContainer = Mapy.Util.node("div", { className: "delete" });

		let title = Mapy.Util.node("h3", {}, "");
		this._dom.deleteTitle = title;

		let text = Mapy.Util.node("p", {});
		this._dom.deleteText = text;

		let buttons = Mapy.Util.node("div", { className: "buttons" });
		let cancelBtn = Mapy.Util.node("button", { className: "cancel", textContent: _("cancel") });
		cancelBtn.setAttribute("type", "button");
		let deleteBtn = Mapy.Util.node("button", { className: "delete", textContent: _("delete") });
		deleteBtn.setAttribute("type", "button");
		buttons.appendChild(deleteBtn);
		buttons.appendChild(cancelBtn);
		this._dom.deleteButtons = buttons;
		this._dom.deleteBtn = deleteBtn;
		this._dom.cancelDeleteBtn = cancelBtn;
		deleteContainer.appendChild(title);
		deleteContainer.appendChild(text);
		deleteContainer.appendChild(buttons);

		this._dom.deleteContainer = deleteContainer;
		this._dom.container.appendChild(this._dom.deleteContainer);
	}
}
